(ns ycweb.app.dashboard.planning.ordered
  (:require
   [rum.core :as rum]
   [ycweb.app.dashboard.planning.common :as planning.cmn]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(def placed-orders-table-config
  {:table-name :admin.planning-new/plan-ordered
   :row-id :stockorder-id
   :data-source {:cursor [:admin.planning-new :placed-orders]}
   :options
   {:order :desc
    :sort-title "YCS"
    :paging? false
    :sticky-header? true}
   :column-defs
   [{:key :companyname :title "Supplier"}
    {:key :brandsordered :title "Brands Ordered" :type :number}
    {:key :brandnames :title "Brands"}
    {:key :stockorder-id :title "YCS"
     :align-class :u-text-center
     :render {:render-k :stockorder-link}}]})

(def placed-orders-table-fns
  {:column-fns
   {:stockorder-link
    (fn [_ _ _ cell-val]
      [:a
       {:href (str "/admin/toorder.htm?action=receiveOrder&id=" cell-val)
        :target "_blank"}
       cell-val])}})

(rum/defc plan-ordered < rum/reactive cmn/cursors [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        placed-orders (cmn/curact process-atom :placed-orders)]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush :align-left :valign-middle])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid :flush :grow-yes])}
       [:div.flex-grid-content
        (headings/heading "Plan Ordered" {:type :h2 :size :large})]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Back to Plan Overview / Suppliers"
          (merge
            (urlstate/href-props app-atom "planning-new" "plan"
              {:planid (:planid (cmn/screen-params app-atom))})
            {:style :secondary
             :size :default}))]]]

     (if (seq placed-orders)
       (datatables/table app-atom :admin.planning-new/plan-ordered placed-orders-table-fns)
       [:p "Nothing to order"])]))

(defmethod flow/render-screen :admin.planning-new/ordered [app-atom _]
  (datatables/initiate app-atom placed-orders-table-config {})
  (planning.cmn/with-loading-overlay app-atom
    (cmn/permission-lock app-atom "SiteAdmin"
      (plan-ordered app-atom))))
